import * as React from 'react';
import { Box } from 'theme-ui';

export const SVG = ({
  size = 32,
  fill = 'none',
  stroke = 'black',
  sx = {},
  viewBox = '0 0 32 32',
  ...props
}: any) => (
  <Box
    as="svg"
    xmlns="http://www.w3.org/2000/svg"
    width={size + ''}
    height={size + ''}
    viewBox={viewBox}
    sx={{ stroke, fill, ...sx }}
    {...props}
  />
);
